// extracted by mini-css-extract-plugin
module.exports = {"mediaGallery":"MediaGallery_mediaGallery__24H58","gallery":"MediaGallery_gallery__17IId","item":"MediaGallery_item__3OwAm"};